document.addEventListener('DOMContentLoaded', function () {
  const thumbnails = document.querySelectorAll('.product_thumbnail_action');
  const featuredImage = document.querySelector('#product__featured-image');

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      if (thumbnail && featuredImage) {
        featuredImage.src = thumbnail.src;
        featuredImage.setAttribute('thumbnail-id', thumbnail.getAttribute('thumbnail-id'))
      }
    });
  });
});


function handleModalScroll() {
  if (jQuery(window).width() > 750) {
    jQuery(document).off('click', '.product-model-openar-action').on('click', '.product-model-openar-action', function() {
      jQuery('body').addClass('overflow-hidden');
      const productModalId = jQuery(this).attr('product-modal-id');
      console.log(productModalId);
      
      if (productModalId) {
        const productModal = jQuery(`product-modal#${productModalId}`);
        
        if (productModal.length) {
          productModal.attr('open', '');
          
          // Get thumbnail-id from clicked element's img
          const thumbnailId = jQuery(this).find('img').attr('thumbnail-id');
          
          if (thumbnailId) {
            const container = productModal.find('.product-media-modal__content');
            const allImages = container.find('img');
            
            // Convert thumbnail-id to index (thumbnail-id starts from 1, index starts from 0)
            const imageIndex = parseInt(thumbnailId) - 1;
            
            if (allImages.length > imageIndex && imageIndex >= 0) {
              const targetImage = allImages.eq(imageIndex);
              
              // Scroll to that image
              container.animate({ 
                scrollTop: targetImage[0].offsetTop 
              }, 300);
            }
          }
        }
      }
    });
  } else {
    jQuery(document).off('click', '.product-model-openar-action');
  }
}


(function checkjQuery() {
  if (typeof jQuery !== 'undefined') {
    jQuery(document).ready(function () {
      jQuery('.desc_wrapper button').on('click', function () {
        let $this = jQuery(this);
        $('.desc_wrapper').hasClass('desc_wrapper-open') ? $('.desc_wrapper').removeClass('desc_wrapper-open') : $('.desc_wrapper').addClass('desc_wrapper-open');
        $this.text() == 'Read More' ? $this.text('Read Less') : $this.text('Read More');
        jQuery('.desc_wrapper').toggleClass('show-4-lines');
      });
      
      // Initialize on page load
      handleModalScroll();

      // Handle window resize
      jQuery(window).on('resize', function() {
        handleModalScroll();
      });

    });
  } else {
    setTimeout(checkjQuery, 50); // Check again in 50ms
  }
})();